// language=GraphQL
export const ALL_NEWSLETTER_REGISTER_BLOCKS_QUERY = `query Query {
  newsletterRegisterBlocks: cmsNewsletterRegisterBlocks {
    id
    fluid
  }
}`

// language=GraphQL
export const SINGLE_NEWSLETTER_REGISTER_BLOCK_QUERY = `query Query($id: ID!) {
  newsletterRegisterBlock: cmsNewsletterRegisterBlock(id: $id) {
    id
    fluid
  }
}`

// language=GraphQL
export const CREATE_NEWSLETTER_REGISTER_BLOCK_MUTATION = `
  mutation Mutation($input: CreateCmsNewsletterRegisterBlockInput) {
    newsletterRegisterBlock: createCmsNewsletterRegisterBlock(input: $input) {
      id
      fluid
    }
  }`

// language=GraphQL
export const UPDATE_NEWSLETTER_REGISTER_BLOCK_MUTATION = `
  mutation Mutation($input: UpdateCmsNewsletterRegisterBlockInput) {
    newsletterRegisterBlock: updateCmsNewsletterRegisterBlock(input: $input) {
      id
      fluid
    }
  }`

// language=GraphQL
export const DELETE_NEWSLETTER_REGISTER_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsNewsletterRegisterBlockInput) {
    deleteCmsNewsletterRegisterBlock(input: $input) {
      success
    }
  }`

// language=GraphQL
export const FORCE_DELETE_NEWSLETTER_REGISTER_BLOCK_MUTATION = `
  mutation Mutation($input: DeleteCmsNewsletterRegisterBlockInput) {
    forceDeleteCmsNewsletterRegisterBlock(input: $input) {
      success
    }
  }`
